<template>
  <div class="client opportunity skills-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog scrollable v-model="editing" max-width="900px" width="66vw" height="50">
      <v-card light>
        <v-card-title class="title">Edit Beneficial Skills</v-card-title>

        <v-divider />

        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-select
              multiple
              chips
              deletable-chips
              label="Behavioral Competencies"
              v-model="modifiedOpportunity.behavioralCompetencies"
              :items="behavioralCompetencies"
              item-text="name"
              item-value="id"
              append-icon="mdi-plus"
              return-object
              :loading="loading"
              :color="themes.client.light.input"
              :menu-props="{ offsetY: true, maxHeight: '30vh' }"
            >
              <template slot="selection" slot-scope="{ item, selected, parent }">
                <v-chip
                  label
                  small
                  @input="parent.onChipInput"
                  :class="themes.client.light.chip"
                  :selected="selected"
                  :key="`personal-trait-${item.id}`"
                >
                  {{ item.name }}
                  <v-icon right small @click="parent.selectItem(item)">mdi-close</v-icon>
                </v-chip>
              </template>
            </v-select>

            <v-combobox
              chips
              multiple
              label="Technical Competencies"
              v-model="modifiedOpportunity.technicalCompetencies"
              :items="technicalCompetencies"
              append-icon="mdi-plus"
              :loading="loading"
              menu-props="{offsetY: true, maxHeight:'30vh'}"
              hint="Skills a candidate should be able to employ during the course of a day."
              :color="themes.client.light.input"
            >
              <template slot="selection" slot-scope="{ item, selected, parent }">
                <v-chip
                  label
                  small
                  @input="parent.onChipInput"
                  class="themes.client.light.chip"
                  :selected="selected"
                  :key="`technical-competencies-${item}`"
                >
                  {{ item }}
                  <v-icon right small @click="parent.selectItem(item)">mdi-close</v-icon>
                </v-chip>
              </template>
            </v-combobox>

            <v-combobox
              multiple
              chips
              label="Professional Tools"
              v-model="modifiedOpportunity.professionalTools"
              :items="[]"
              append-icon=""
              :loading="loading"
              :color="themes.client.light.input"
            >
              <template slot="selection" slot-scope="{ item, selected, parent }">
                <v-chip
                  label
                  small
                  @input="parent.onChipInput"
                  class="themes.client.light.chip"
                  :selected="selected"
                  :key="`professional-tools-${item}`"
                >
                  {{ item }}
                  <v-icon right small @click="parent.selectItem(item)">mdi-close</v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="editing = false" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn :color="themes.client.light.primaryActionButton" :disabled="!valid" @click="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Data
import technicalCompetencies from '@/data/technical_competencies'

// Helpers
import { mapGetters } from 'vuex'

export default {
  created() {
    this.$store.dispatch('behavioralCompetencies/fetchAll')
  },

  props: {
    opportunity: Object,
    edit: Boolean,
  },

  data() {
    return {
      // Model
      modifiedOpportunity: JSON.parse(JSON.stringify(this.opportunity)),
      editing: false,
      loading: false,
      valid: false,
      technicalCompetencies,
    }
  },

  computed: mapGetters({
    behavioralCompetencies: 'behavioralCompetencies/all',
  }),

  watch: {
    editing() {
      this.modifiedOpportunity = JSON.parse(JSON.stringify(this.opportunity))
    },
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        this.$store
          .dispatch('client/opportunities/update', this.modifiedOpportunity)
          .then(errors => {
            if (errors) {
              this.errors = errors
              this.$store.dispatch('snackbarError', 'Opportunity Failed to Save')
            } else {
              this.$store.dispatch('snackbarSuccess', 'Opportunity Saved')
              this.editing = false
              this.refresh()
            }
          })
      }
      // Object.assign(this.opportunity, this.modified)
    },

    refresh() {
      this.$store.dispatch('client/opportunities/fetch', this.$route.params.id).then(() => {
        this.loading = false
      })
    },
  },
}
</script>
